import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 45,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="flex justify-center space-x-2 text-center my-4" data-id="element-168">
      <div className="bg-red-600 text-white rounded px-3 py-2 min-w-[60px]" data-id="element-169">
        <span className="text-2xl font-bold" data-id="element-170">
          {String(timeLeft.hours).padStart(2, '0')}
        </span>
        <div className="text-[10px] uppercase" data-id="element-171">Horas</div>
      </div>
      <div className="text-red-600 text-2xl font-bold py-1" data-id="element-172">:</div>
      <div className="bg-red-600 text-white rounded px-3 py-2 min-w-[60px]" data-id="element-173">
        <span className="text-2xl font-bold" data-id="element-174">
          {String(timeLeft.minutes).padStart(2, '0')}
        </span>
        <div className="text-[10px] uppercase" data-id="element-175">Minutos</div>
      </div>
      <div className="text-red-600 text-2xl font-bold py-1" data-id="element-176">:</div>
      <div className="bg-red-600 text-white rounded px-3 py-2 min-w-[60px]" data-id="element-177">
        <span className="text-2xl font-bold" data-id="element-178">
          {String(timeLeft.seconds).padStart(2, '0')}
        </span>
        <div className="text-[10px] uppercase" data-id="element-179">Segundos</div>
      </div>
    </div>;
}